module.exports = __webpack_public_path__ + "img/ground-mountain-evening.8afd57a3.png";